import { render, staticRenderFns } from "./PowerConsumptionAmpsList.vue?vue&type=template&id=4bdace16&"
import script from "./PowerConsumptionAmpsList.vue?vue&type=script&lang=js&"
export * from "./PowerConsumptionAmpsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports